import { lazy } from 'react';

// Reports page with heavy charts - prefetch for better UX
export const LazyReports = lazy(() => 
  import(/* webpackChunkName: "reports", webpackPrefetch: true */ '@/pages/Reports')
    .then(module => ({ default: module.Reports }))
);
